export * from "./../contractLaw/applicationStatus";

export const APPLICATION_STATUS_CONTRACT_PARTY_TYPE = 15;
